import React from 'react';
import { Link } from 'react-router-dom';
import DocumentSection from '../components/sections/DocumentSection';

const DocumentAI: React.FC = () => {
    return (
        <div>
            {/* Hero Section */}
            <section className="bg-primary py-20">
                <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 font-inter">
                            Document AI
                        </h1>
                        <p className="text-xl text-gray-100 mb-8 max-w-3xl mx-auto">
                            Extract insights and automate document processing with advanced AI technology
                        </p>
                    </div>
                </div>
            </section>

            <DocumentSection />

            {/* CTA Section */}
            <section className="py-14 bg-white border-t border-gray-100 mt-10">
                <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-3xl md:text-4xl font-bold text-[#0B1538] mb-4">
                        Transform Your Document Processing
                    </h2>
                    <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
                        Experience the power of AI in handling your document workflows.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <Link
                            to="/contact"
                            className="px-8 py-4 bg-[#0B25E6] text-white rounded-lg hover:bg-blue-800  transition-colors text-lg font-semibold"
                        >
                            Get Started
                        </Link>
                        <Link
                            to="/contact"
                            className="px-8 py-4 text-white border-2 border-white rounded-lg hover:bg-blue-800 text-white transition-colors text-lg font-semibold"
                        >
                            Talk to an Expert
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default DocumentAI;
